export default __webpack_public_path__ + "static/media/description.071e98ee.svg";